<template>
  <button class="btn">
    <slot name="prepend" />
    <span class="txt_btn">{{ text }}</span>
    <slot />
  </button>
</template>

<script lang="ts" setup>
const { text } = defineProps({
  text: {
    type: String,
    default: ''
  }
})
</script>

<style lang="scss" scoped>
.btn {
  display: flex;
  text-align: center;
}
</style>
